/** Kinship group ids map to i18n keys under kinship.groups.* */
export const KINSHIP_GROUP_IDS = [
  'yellowThunderbirds',
  'redThunderbirds',
  'blackThunderbirds',
  'whiteThunderbirds',
  'yellowOak',
  'redOak',
  'blackOak',
  'whiteOak',
  'yellowWhale',
  'redWhale',
  'blackWhale',
  'whiteWhale'
] as const;

export type KinshipGroupId = (typeof KINSHIP_GROUP_IDS)[number];

/** Legacy English names stored in Firestore / localStorage */
export const KINSHIP_GROUP_LEGACY_NAMES: Record<string, KinshipGroupId> = {
  'yellow thunderbirds': 'yellowThunderbirds',
  'red thunderbirds': 'redThunderbirds',
  'black thunderbirds': 'blackThunderbirds',
  'white thunderbirds': 'whiteThunderbirds',
  'yellow thunder birds': 'yellowThunderbirds',
  'red thunder birds': 'redThunderbirds',
  'black thunder birds': 'blackThunderbirds',
  'white thunder birds': 'whiteThunderbirds',
  'yellow oak tree': 'yellowOak',
  'red oak tree': 'redOak',
  'black oak tree': 'blackOak',
  'white oak tree': 'whiteOak',
  'yellow whale': 'yellowWhale',
  'red whale': 'redWhale',
  'black whale': 'blackWhale',
  'white whale': 'whiteWhale'
};

/** English names persisted in Firestore */
export const KINSHIP_GROUP_ENGLISH: Record<KinshipGroupId, string> = {
  yellowThunderbirds: 'Yellow Thunder Birds',
  redThunderbirds: 'Red Thunder Birds',
  blackThunderbirds: 'Black Thunder Birds',
  whiteThunderbirds: 'White Thunder Birds',
  yellowOak: 'Yellow Oak Tree',
  redOak: 'Red Oak Tree',
  blackOak: 'Black Oak Tree',
  whiteOak: 'White Oak Tree',
  yellowWhale: 'Yellow Whale',
  redWhale: 'Red Whale',
  blackWhale: 'Black Whale',
  whiteWhale: 'White Whale'
};

export const getKinshipGroupId = (name: string): KinshipGroupId | null => {
  const key = name.trim().toLowerCase();
  return KINSHIP_GROUP_LEGACY_NAMES[key] ?? null;
};

export const translateKinshipGroup = (
  name: string,
  t: (key: string) => string
): string => {
  const id = getKinshipGroupId(name);
  if (id) {
    return t(`kinship.groups.${id}`);
  }
  return name;
};
